import { render } from "./item-tariff-main.vue?vue&type=template&id=1fe788c7&scoped=true"
import script from "./item-tariff-main.vue?vue&type=script&lang=js"
export * from "./item-tariff-main.vue?vue&type=script&lang=js"

import "./item-tariff-main.vue?vue&type=style&index=0&id=1fe788c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe788c7"]])

export default __exports__